var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityStatusComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D2D9ED",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.513 13.54l-6.697 6.697c-.5.5-1.31.5-1.808 0L8.47 16.699a1.279 1.279 0 0 1 1.807-1.807l2.636 2.635 5.793-5.795a1.278 1.278 0 1 1 1.807 1.808",
    fill: "#596F85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityStatusComplete);
export default __webpack_public_path__ + "static/media/activity-status-complete.bb141d858d891a65008f0964bb497c37.svg";
export { ForwardRef as ReactComponent };